import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { ProposalProjectSavingsStaff } from "../Model/ProposalProjectSavingsStaff";

export async function getProposalProjectSavingsStaff(idProposalProject) {
	let response = await getAPIResponse("/v1/proposal-project-staff/"+idProposalProject);
	if (response === null) {
		return null;
	}
	let proposalProjectSavingsStaff = response.map(data => ProposalProjectSavingsStaff.createFromResponseData(data));
	return proposalProjectSavingsStaff;
}
